import googleMaps from '@services/google-maps';

function load(elementId: string, mapOptions: google.maps.MapOptions, cb?: (map: google.maps.Map) => void) {
  return googleMaps.loader
    .load()
    .then((google) => {
      const element = document.getElementById(elementId);
      if (!element) throw new Error('Element not found');
      const map = new google.maps.Map(element, mapOptions);
      if (cb) cb(map);
    })
    .catch(() => {
      // TODO: handle error?
    });
}
function loadPlaces(selector: string, selectAddress: (place: google.maps.places.PlaceResult) => void) {
  const autoCompleteInput: HTMLInputElement | null = document.querySelector(selector);

  return googleMaps.loader.load().then((google) => {
    const autocomplete = new google.maps.places.Autocomplete(autoCompleteInput as HTMLInputElement, {
      componentRestrictions: { country: 'US' },
      fields: ['address_components'],
    });
    autocomplete.addListener('place_changed', async () => {
      const place = autocomplete.getPlace();
      selectAddress(place);
    });
  });
}

function marker(markerOptions: google.maps.MarkerOptions) {
  new google.maps.Marker(markerOptions);
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
  }
  return { load, loadPlaces, marker };
})();
